import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import SiteLayout from "@/components/site/SiteLayout";
import { api } from "@/lib/api";
import { ArrowRight } from "lucide-react";

// SEO category page for /sell/:brand-slug — auto-generated marketing page for any brand.
export default function Category() {
  const { brand } = useParams();
  const [b, setB] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    api.get(`/brands/${brand}`).then((r) => setB(r.data)).catch(() => setNotFound(true));
  }, [brand]);

  if (notFound) return <SmartNotFound suggestion={brand} />;
  if (!b) return null;

  const est50 = Math.round(50 * b.rate_percent) / 100;
  const est100 = Math.round(100 * b.rate_percent) / 100;
  const est500 = Math.round(500 * b.rate_percent) / 100;

  return (
    <SiteLayout>
      <section className="section-py container-x">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-bold uppercase mb-4">{b.category}</span>
        <h1 className="text-5xl md:text-6xl font-extrabold tracking-tight max-w-3xl">Sell your {b.name} gift card for up to <span className="text-primary">{b.rate_percent}%</span> cash.</h1>
        <p className="mt-4 text-muted-foreground text-lg max-w-2xl">{b.description}</p>

        <div className="mt-10 grid md:grid-cols-3 gap-4">
          {[{a:50,e:est50},{a:100,e:est100},{a:500,e:est500}].map(({a,e}) => (
            <div key={a} className="card-soft">
              <div className="text-xs uppercase font-bold text-muted-foreground">${a} card =</div>
              <div className="text-4xl font-extrabold text-primary mt-2">${e}</div>
            </div>
          ))}
        </div>

        <div className="mt-10">
          <Link to={`/submit?brand=${encodeURIComponent(b.name)}`} className="btn-pill">Sell my {b.name} card <ArrowRight size={14} className="ml-2" /></Link>
        </div>

        <div className="mt-20 grid md:grid-cols-2 gap-6">
          <div className="card-soft">
            <h3 className="font-extrabold text-xl">Why sell {b.name} to {`GC Nexon`}?</h3>
            <ul className="mt-4 space-y-2 text-sm">
              <li>• Industry-leading {b.rate_percent}% rate on {b.name}.</li>
              <li>• Same-day payout after verification.</li>
              <li>• Get paid via PayPal, Cash App, Zelle, Chime, or Bitcoin.</li>
            </ul>
          </div>
          <div className="card-soft">
            <h3 className="font-extrabold text-xl">How the {b.name} payout works</h3>
            <ol className="mt-4 space-y-2 text-sm list-decimal list-inside">
              <li>Submit your card details + photo.</li>
              <li>We verify balance (usually under 4 hours).</li>
              <li>Cash lands in your wallet once verification wraps up.</li>
            </ol>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}

function SmartNotFound({ suggestion }) {
  return (
    <SiteLayout>
      <section className="section-py container-x max-w-2xl">
        <h1 className="text-5xl font-extrabold">We don't buy {suggestion?.replace(/-/g, " ") || "that brand"} yet.</h1>
        <p className="mt-4 text-muted-foreground text-lg">But we do buy 100+ major brands. Take a look?</p>
        <Link to="/rates" className="btn-pill mt-8 inline-flex">See what we buy</Link>
      </section>
    </SiteLayout>
  );
}
